/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate(['AUTH_SUCCESS', 'AUTH_FAILURE', 'TOKEN_ENTRY']);
